import { NGXLogger } from "ngx-logger";
import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { ConfigService } from "../config/config.service";

/** Servizio per la gestione del login */
@Injectable({
  providedIn: "root"
})
export class GestioneLoginService {

  // Errors
  private LOGIN_ERRORS = {
    user_not_found: "Utente non trovato in atlante",
    auth_error: "Errore in fase di autenticazione"
  };

  /** subject per comunicare all'esterno il login */
  private loginSubject = new Subject<any>();

  /** costruttore */
  constructor(
    private configService: ConfigService,
    private logger: NGXLogger
  ) { }

  // ------------------------------------------------------------------------------------------

  getErrorMessage(errorCode) {
    return this.LOGIN_ERRORS[errorCode] || 'Errore in fase di Login';
  }

  // ------------------------------------------------------------------------------------------

  // Microsoft Azure AD SSO
  setToken(token: string): void {
    sessionStorage.setItem("jwt", token);
  }

  // ------------------------------------------------------------------------------------------

  // Microsoft Azure AD SSO
  setRefresh(refresh: string): void {
    sessionStorage.setItem("refresh", refresh);
  }

  // ------------------------------------------------------------------------------------------

  // Microsoft Azure AD SSO
  clearToken(): void {
    sessionStorage.removeItem("jwt");
    sessionStorage.removeItem("refresh");
  }

  // ------------------------------------------------------------------------------------------

  // Microsoft Azure AD SSO
  getToken(): string | null {
    return sessionStorage.getItem("jwt");
  }

  // ------------------------------------------------------------------------------------------

  // Microsoft Azure AD SSO
  getRefresh(): string | null {
    return sessionStorage.getItem("refresh");
  }

  // ------------------------------------------------------------------------------------------

  // Microsoft Azure AD SSO
  userIsLoggedIn(): boolean {
    return sessionStorage.getItem("jwt") != null;
  }

  // ------------------------------------------------------------------------------------------

  /** Metodo per ascoltare il login */
  ascoltaLogin(): Observable<any> {
    return this.loginSubject.asObservable();
  }

  // ------------------------------------------------------------------------------------------

  /**
   * generatore di URL per raggiungere il backend
   * @param sezione sezione del file di configurazione (campo key del campo routes)
   * @param id identificativo della rotta (campo id del paths)
   * @returns URL completo
   */
  creaURL(sezione: string, id: string) {
    try {
      const path: string = this.configService
        .getConfigGlobale()
        .api.routes.find((r) => r.key === sezione)
      ["paths"].find((p) => p.id === id).path;

      if (this.configService.getConfigGlobale().api.server.apiRelativePath) {
        return (
          this.configService.getConfigGlobale().api.server.apiRelativePath +
          path
        );
      } else {
        const serverAddress: string =
          this.configService.getConfigGlobale().api.server.apiProtocol +
          this.configService.getConfigGlobale().api.server.apiIp;
        const routeAddress: string = this.configService
          .getConfigGlobale()
          .api.routes.find((r) => r.key === sezione)["routeIp"];
        const pathAddress: string = this.configService
          .getConfigGlobale()
          .api.routes.find((r) => r.key === sezione)
        ["paths"].find((p) => p.id === id).pathIp;
        const serverPort: number =
          this.configService.getConfigGlobale().api.server.apiPort;
        const routePort: number = this.configService
          .getConfigGlobale()
          .api.routes.find((r) => r.key === sezione)["routePort"];
        const pathPort: number = this.configService
          .getConfigGlobale()
          .api.routes.find((r) => r.key === sezione)
        ["paths"].find((p) => p.id === id).pathPort;

        // Addresses and ports have a priority order: from single path to server.
        const address: string = pathAddress
          ? pathAddress
          : routeAddress
            ? routeAddress
            : serverAddress;
        const port: number = pathPort
          ? pathPort
          : routePort
            ? routePort
            : serverPort;

        return address + ":" + port + path;
      }
    } catch {
      this.logger.error(
        `Impossibile Generare il path ${sezione}/${id}. Controllare in ../assets/config/config-globale.dev.json`
      );
      return "";
    }
  }

  // ------------------------------------------------------------------------------------------

  /**
   * Metodo per generare l'url del back avendo già la rotta desiderata
   * @param route rotta da utilizzare per creare l'URL
   */
  creaUrlDaRoute(route: string): string {
    if (this.configService.getConfigGlobale().api.server.apiRelativePath) {
      return (
        this.configService.getConfigGlobale().api.server.apiRelativePath + route
      );
    } else {
      return (
        this.configService.getConfigGlobale().api.server.apiProtocol +
        this.configService.getConfigGlobale().api.server.apiIp +
        ":" +
        this.configService.getConfigGlobale().api.server.apiPort +
        route
      );
    }
  }
}
